// Module
var code = "<div class=\"blueprint-section\"> <iframe ng-src=\"{{ url }}\" width=\"100%\" height=\"{{ frameHeight }}\" frameborder=\"0\" id=\"blueprint-frame\"></iframe> </div> ";
// Exports
module.exports = code;